import { Turbo } from "@hotwired/turbo-rails";

// Custom Turbo Actions
Turbo.StreamActions.create_datagrid_row = function () {
  document.dispatchEvent(
    new CustomEvent("create-datagrid-row", {
      detail: {
        id: this.getAttribute("id"),
        data: JSON.parse(this.getAttribute("data")),
      },
    }),
  );
};

Turbo.StreamActions.update_datagrid_row = function () {
  document.dispatchEvent(
    new CustomEvent("update-datagrid-row", {
      detail: {
        id: this.getAttribute("id"),
        data: JSON.parse(this.getAttribute("data")),
      },
    }),
  );
};

Turbo.StreamActions.delete_datagrid_rows = function () {
  document.dispatchEvent(
    new CustomEvent("delete-datagrid-rows", {
      detail: {
        ids: JSON.parse(this.getAttribute("ids")),
      },
    }),
  );
};

Turbo.StreamActions.show_datagrid_alert = function () {
  document.dispatchEvent(
    new CustomEvent("show-datagrid-alert", {
      detail: {
        message: this.getAttribute("message"),
      },
    }),
  );
};
